export enum OptionType {
  Checkbox,
  Radio,
}

export enum Categories {
  Database,
  Access,
  Duration,
  Support,
  Type,
  Usage,
  Extras,
}

export interface IOption {
  Key: string;
  Description: string;
  Category: Categories;
  Price?: number;
  Selected: boolean;
  Type: OptionType;
}

export interface IOptionSection {
  Type: OptionType;
  Options: IOption[];
}
